import React from "react";
import "../css/faq.css";
import faq2 from "../asset/Helpdesk-PNG-File.png";

const FAQ = () => {
  return (
    <div>
      <section id="faq">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="left-in">
                <h2 className="faq-head">Frequently Asked Questions</h2>
                <p className="faq-sub">
                  Find answers to common questions and get the help you need.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <img
                className="img-fluid"
                src={faq2}
                alt="Helpdesk Illustration"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="question">
        <div className="container">
          <div className="row">
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {/** Question 1 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingOne">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    When will the school academic session start for 2025-26?
                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingOne"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The academic session for 2025-26 will begin in June 2025.
                  </div>
                </div>
              </div>
              {/** Question 2 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
                    What are the school timings?
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTwo"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <strong>SMG KIDS:</strong>
                    <ul>
                      <li>Senior KG: 8:00 AM to 11:30 AM</li>
                      <li>Nursery and Junior KG: 1:00 PM to 4:15 PM</li>
                    </ul>
                    <strong>SMG English School:</strong>
                    <ul>
                      <li>Std 1 to 7: 7:00 AM to 12:10 PM</li>
                      <li>Std 8 to 10: 12:45 PM to 5:30 PM</li>
                    </ul>
                    <p>*Note: The timings are subject to change.*</p>
                  </div>
                </div>
              </div>
              {/** Question 3 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                  >
                    What grades will be operational in the school for 2025-26?
                  </button>
                </h2>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingThree"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    SMG English School will be operational from Nursery (age 3)
                    to Grade 7 for the academic year 2025-26. Each subsequent
                    year, the school will add one grade until Grade 10 is
                    reached.
                  </div>
                </div>
              </div>
              {/** Question 4 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour"
                    aria-expanded="false"
                    aria-controls="flush-collapseFour"
                  >
                    What is the age criteria for admission?
                  </button>
                </h2>
                <div
                  id="flush-collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingFour"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <ul>
                      <li>Nursery: 3 years as of 31 December 2025</li>
                      <li>Junior KG: 4 years as of 31 December 2025</li>
                      <li>Senior KG: 5 years as of 31 December 2025</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/** Question 5 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFive"
                    aria-expanded="false"
                    aria-controls="flush-collapseFive"
                  >
                    When does the admission process begin?
                  </button>
                </h2>
                <div
                  id="flush-collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingFive"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Admissions for SMG KIDS and SMG English School (Std 1
                    onwards) are ongoing. Seats are limited and are allocated on
                    a first-come, first-served basis.
                  </div>
                </div>
              </div>
              {/** Question 6 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSix">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSix"
                    aria-expanded="false"
                    aria-controls="flush-collapseSix"
                  >
                    What is the admission process?
                  </button>
                </h2>
                <div
                  id="flush-collapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingSix"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <ol>
                      <li>
                        Visit the school website or collect the form from the
                        school office. <span>www.smgschools.co.in</span>
                      </li>
                      <li>
                        Fill out the Enquiry Form and upload the required
                        documents:
                        <ul>
                          <li>Student's Birth Certificate</li>
                          <li>Student's Aadhaar Card</li>
                          <li>Bonafide Certificate (Std 2 onwards)</li>
                          <li>Passport-size photograph of the student</li>
                        </ul>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
              {/** Question 7 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSeven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSeven"
                    aria-expanded="false"
                    aria-controls="flush-collapseSeven"
                  >
                    Will there be an increase in school fees every year?
                  </button>
                </h2>
                <div
                  id="flush-collapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingSeven"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    School fees will increase by 15% every three years. The
                    first year will have no fee increase, followed by a 15%
                    increment in the subsequent year, continuing in this cycle.
                  </div>
                </div>
              </div>
              {/** Question 8 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingEight">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseEight"
                    aria-expanded="false"
                    aria-controls="flush-collapseEight"
                  >
                    How is the fee payment structured?
                  </button>
                </h2>
                <div
                  id="flush-collapseEight"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingEight"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Fees are payable in three installments:
                    <ul>
                      <li>First installment: At the time of admission</li>
                      <li>Second installment: Before Term 1 exams</li>
                      <li>Third installment: Before Term 2 exams</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 9 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingNine">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseNine"
                    aria-expanded="false"
                    aria-controls="flush-collapseNine"
                  >
                    In what name should the fee cheques be made?
                  </button>
                </h2>
                <div
                  id="flush-collapseNine"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingNine"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <ul>
                      <li>Nursery to Senior KG: _______</li>
                      <li>Std 1 onwards: _______</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 10 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTen"
                    aria-expanded="false"
                    aria-controls="flush-collapseTen"
                  >
                    What infrastructure does the school provide?
                  </button>
                </h2>
                <div
                  id="flush-collapseTen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    SMG English School offers a fun and interactive learning
                    environment with:
                    <ul>
                      <li>
                        <strong>Classrooms:</strong> Equipped with projectors
                        and visualizers
                      </li>
                      <li>
                        <strong>Labs:</strong> Robotics, computer, and science
                        labs
                      </li>
                      <li>
                        <strong>Library:</strong> Well-stocked with
                        age-appropriate resources
                      </li>
                      <li>
                        <strong>Washrooms:</strong> Clean and hygienic
                        facilities
                      </li>
                      <li>
                        <strong>Water Facility:</strong> Purified and safe
                        drinking water
                      </li>
                      <li>
                        <strong>Sports:</strong> Indoor sports rooms and a
                        playground for outdoor games
                      </li>
                      <li>
                        <strong>Note:</strong> The school does not provide
                        canteen services. Students should carry healthy food to
                        school.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 11 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingEleven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseEleven"
                    aria-expanded="false"
                    aria-controls="flush-collapseEleven"
                  >
                    What sports facilities does the school provide?
                  </button>
                </h2>
                <div
                  id="flush-collapseEleven"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingEleven"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The school offers:
                    <ul>
                      <li>Provisions for indoor and outdoor sports</li>
                      <li>A playground for outdoor games</li>
                      <li>Participation in DSO sports events</li>
                      <li>Regular physical education classes</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 12 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwelve">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwelve"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwelve"
                  >
                    Is there a school bus facility?
                  </button>
                </h2>
                <div
                  id="flush-collapseTwelve"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTwelve"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes, the school provides bus services with extensive routes.
                    Each bus is equipped with:
                    <ul>
                      <li>A trained driver and one lady attendant</li>
                      <li>
                        Speed governors, GPS trackers (Chakraview App), and CCTV
                        cameras for safety
                      </li>
                      <li>
                        <strong>Note:</strong> The school bus service is
                        recommended but optional.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 13 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingThirteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThirteen"
                    aria-expanded="false"
                    aria-controls="flush-collapseThirteen"
                  >
                    Are CCTV cameras installed on the school premises?
                  </button>
                </h2>
                <div
                  id="flush-collapseThirteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingThirteen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes, CCTV cameras are installed throughout the school
                    premises to ensure student safety.
                  </div>
                </div>
              </div>

              {/** Question 14 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFourteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFourteen"
                    aria-expanded="false"
                    aria-controls="flush-collapseFourteen"
                  >
                    How many students are there per division (approximately)?
                  </button>
                </h2>
                <div
                  id="flush-collapseFourteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingFourteen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <ul>
                      <li>Nursery: 35 students</li>
                      <li>Junior KG & Senior KG: 40 students</li>
                      <li>Std 1 to 10: 55 students</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 15 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFifteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFifteen"
                    aria-expanded="false"
                    aria-controls="flush-collapseFifteen"
                  >
                    In which competitive activities do students participate?
                  </button>
                </h2>
                <div
                  id="flush-collapseFifteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingFifteen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    SMG English School encourages participation in:
                    <ul>
                      <li>
                        District Sports Organization (DSO) events like skating
                        and athletics
                      </li>
                      <li>Elementary and Intermediate Drawing Examinations</li>
                      <li>Dr. Homi Bhabha Balvaidnyanik Science Competition</li>
                      <li>
                        Inter-school activities such as debate, elocution, and
                        quizzes
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 16 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSixteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSixteen"
                    aria-expanded="false"
                    aria-controls="flush-collapseSixteen"
                  >
                    How is the curriculum designed?
                  </button>
                </h2>
                <div
                  id="flush-collapseSixteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingSixteen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The curriculum is balanced to ensure academic excellence,
                    co-curricular engagement, and moral education, incorporating
                    modern teaching techniques for all learners.
                  </div>
                </div>
              </div>

              {/** Question 17 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSeventeen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSeventeen"
                    aria-expanded="false"
                    aria-controls="flush-collapseSeventeen"
                  >
                    Will students be involved in extracurricular activities?
                  </button>
                </h2>
                <div
                  id="flush-collapseSeventeen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingSeventeen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes, activities include:
                    <ul>
                      <li>Art, dance, and music classes</li>
                      <li>Sports tournaments and inter-house competitions</li>
                      <li>Celebrations of festivals and national events</li>
                      <li>Educational trips and excursions</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/** Question 18 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingEighteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseEighteen"
                    aria-expanded="false"
                    aria-controls="flush-collapseEighteen"
                  >
                    Is the inter-school transfer option available between SMG
                    English Schools at different locations?
                  </button>
                </h2>
                <div
                  id="flush-collapseEighteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingEighteen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Yes, this is possible. Existing SMG students (e.g., from
                    Dombivli) are given first preference in admissions.
                  </div>
                </div>
              </div>

              {/** Question 19 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingNineteen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseNineteen"
                    aria-expanded="false"
                    aria-controls="flush-collapseNineteen"
                  >
                    How are parents kept informed about their child’s progress?
                  </button>
                </h2>
                <div
                  id="flush-collapseNineteen"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingNineteen"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Parents receive updates via SMS, emails, and parent-teacher
                    meetings. Regular progress reports are shared to keep
                    parents informed about their child's academic and
                    extracurricular performance.
                  </div>
                </div>
              </div>

              {/** Question 21 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTweentyOne">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTweentyOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseTweentyOne"
                  >
                    What payment methods are accepted for fees ?
                  </button>
                </h2>
                <div
                  id="flush-collapseTweentyOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTweentyOne"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Payment can be made via: Cash, Cheques and Online (via
                    school portal) Note: School fee can also be paid in
                    installment.
                  </div>
                </div>
              </div>

              {/** Question 20 **/}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingtweenty">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsetweenty"
                    aria-expanded="false"
                    aria-controls="flush-collapsetweenty"
                  >
                    What happen if my child falls ill during school hours?
                  </button>
                </h2>
                <div
                  id="flush-collapsetweenty"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingtweenty"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The school has a first-aid facility, and in case of
                    emergencies, parents are contected immidiately.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
